import React from 'react';
import s from './index.scss';

const LiveIcon = ({ text = 'LIVE', itemIconClass, largeSize = false }) => (
  <div
    className={`${s.liveBlinker} ${s[itemIconClass]} ${
      largeSize ? s.largeSize : ''
    }`}
  >
    <i />
    {text}
  </div>
);

export default LiveIcon;
